(function () {
  'use strict';

  var WRAPPER_SELECTOR = '[data-hotp-personalization]';
  var INPUT_SELECTOR = '[data-personalization-input]';
  var PRODUCT_CONTAINER_SELECTOR =
    '.product-section, [data-section-type="product"]';

  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function isPersonalizableSignature(value) {
    var normalized = normalize(value);

    return (
      normalized.indexOf('signed by author') !== -1 ||
      normalized.indexOf('signed bookplate') !== -1
    );
  }

  function getProductContainer(wrapper) {
    if (!wrapper) return null;

    return wrapper.closest(PRODUCT_CONTAINER_SELECTOR);
  }

  function getForm(wrapper) {
    if (!wrapper) return null;

    return wrapper.closest('form.product-single__form');
  }

  function getInput(wrapper) {
    return wrapper
      ? wrapper.querySelector(INPUT_SELECTOR)
      : null;
  }

  function setPersonalizationVisibility(wrapper, show) {
    if (!wrapper) return;

    var input = getInput(wrapper);

    if (!input) return;

    wrapper.hidden = !show;
    input.disabled = !show;

    /*
     * If someone enters a name and then switches
     * back to Unsigned, discard the old name.
     */
    if (!show) {
      input.value = '';
    }

    syncDynamicCheckout(wrapper);
  }

  function syncDynamicCheckout(wrapper) {
    var form = getForm(wrapper);
    var input = getInput(wrapper);

    if (!form || !input) return;

    var dynamicCheckout = form.querySelector(
      '[data-personalization-dynamic-checkout]'
    );

    if (!dynamicCheckout) return;

    var hasPersonalization =
      !input.disabled &&
      input.value.trim().length > 0;

    dynamicCheckout.hidden = hasPersonalization;
  }

  /*
   * Read the currently selected value of one of
   * Impulse's native variant options.
   */
  function getCurrentOptionValue(container, optionIndex) {
    if (!container || !optionIndex) return null;

    var inputs = container.querySelectorAll(
      '[data-variant-input]'
    );

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];

      if (input.dataset.index !== optionIndex) {
        continue;
      }

      var type = input.getAttribute('type');

      if (type === 'radio' || type === 'checkbox') {
        if (input.checked) {
          return input.value;
        }
      } else {
        return input.value;
      }
    }

    return null;
  }

  /*
   * Establish correct visibility from whatever
   * Impulse currently has selected.
   */
  function syncFromCurrentVariant(wrapper) {
    var signatureIndex =
      wrapper.dataset.personalizationSignatureIndex;

    /*
     * No Signature option on this product:
     * personalization is always available.
     */
    if (!signatureIndex) {
      setPersonalizationVisibility(wrapper, true);
      return;
    }

    var container = getProductContainer(wrapper);

    if (!container) return;

    var value = getCurrentOptionValue(
      container,
      signatureIndex
    );

    if (value === null) return;

    setPersonalizationVisibility(
      wrapper,
      isPersonalizableSignature(value)
    );
  }

  function bindVariantHandling(wrapper) {
    var container = getProductContainer(wrapper);

    if (!container) return;

    /*
     * Impulse fires variantChange ON the individual
     * product container. This means an embedded product,
     * normal PDP, quick view, etc. each updates itself.
     */
    container.addEventListener(
      'variantChange',
      function (event) {
        if (!event.detail) return;

        var signatureIndex =
          wrapper.dataset.personalizationSignatureIndex;

        if (!signatureIndex) {
          setPersonalizationVisibility(
            wrapper,
            true
          );
          return;
        }

        var selectedValues =
          event.detail.currentlySelectedValues || [];

        var signatureSelection =
          selectedValues.find(function (option) {
            return option.index === signatureIndex;
          });

        if (!signatureSelection) {
          /*
           * Native change fallback below will normally
           * cover this, but re-read Impulse's controls
           * just in case.
           */
          syncFromCurrentVariant(wrapper);
          return;
        }

        var isSigned =
          isPersonalizableSignature(
            signatureSelection.value
          );

        setPersonalizationVisibility(
          wrapper,
          isSigned
        );
      }
    );

    /*
     * Fallback: listen to Impulse's native option
     * controls inside THIS product container.
     */
    container.addEventListener(
      'change',
      function (event) {
        var target = event.target;

        if (
          !target ||
          !target.matches('[data-variant-input]')
        ) {
          return;
        }

        var signatureIndex =
          wrapper.dataset.personalizationSignatureIndex;

        if (
          !signatureIndex ||
          target.dataset.index !== signatureIndex
        ) {
          return;
        }

        setPersonalizationVisibility(
          wrapper,
          isPersonalizableSignature(target.value)
        );
      }
    );
  }

  function bindInputHandling(wrapper) {
    var input = getInput(wrapper);

    if (!input) return;

    input.addEventListener(
      'input',
      function () {
        syncDynamicCheckout(wrapper);
      }
    );
  }

  /*
   * Custom submission only happens when the customer
   * actually entered a personalization name.
   */
  function bindFormHandling(wrapper) {
    var form = getForm(wrapper);

    if (!form) return;

    form.addEventListener(
      'submit',
      async function (event) {
        var input = getInput(wrapper);

        if (!input || input.disabled) {
          return;
        }

        var personalizationName =
          input.value.trim();

        /*
         * Signed but NOT personalized:
         * let Impulse submit normally.
         */
        if (!personalizationName) {
          return;
        }

        var feeVariantId = Number(
          wrapper.dataset.personalizationFeeVariantId
        );

        var variantField =
          form.querySelector('[data-product-select]') ||
          form.querySelector('[name="id"]');

        var mainVariantId = variantField
          ? Number(variantField.value)
          : 0;

        if (!feeVariantId || !mainVariantId) {
          event.preventDefault();
          event.stopImmediatePropagation();

          alert(
            'Personalization could not be added. Please refresh the page and try again.'
          );

          return;
        }

        /*
         * Stop Impulse's normal Add to Cart request.
         * We'll send the book + fee together.
         */
        event.preventDefault();
        event.stopImmediatePropagation();

        var formData = new FormData(form);

        var quantity = Number(
          formData.get('quantity') || 1
        );

        if (!quantity || quantity < 1) {
          quantity = 1;
        }

        var properties = {};

        formData.forEach(function (value, key) {
          var match =
            key.match(/^properties\[(.+)\]$/);

          if (
            match &&
            typeof value === 'string' &&
            value !== ''
          ) {
            properties[match[1]] = value;
          }
        });

        var mainItem = {
          id: mainVariantId,
          quantity: quantity,
          properties: properties
        };

        var sellingPlan =
          formData.get('selling_plan');

        if (sellingPlan) {
          mainItem.selling_plan =
            Number(sellingPlan);
        }

        /*
         * Paid personalization is a nested child
         * of the actual book/bundle.
         */
        var feeItem = {
          id: feeVariantId,
          quantity: quantity,
          parent_id: mainVariantId
        };

        var addButton = form.querySelector(
          '[data-add-to-cart]'
        );

        var buttonWasDisabled = addButton
          ? addButton.disabled
          : false;

        if (addButton) {
          addButton.classList.add(
            'btn--loading'
          );

          addButton.disabled = true;
        }

        var root =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        try {
          var response = await fetch(
            root + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                'X-Requested-With':
                  'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: [
                  mainItem,
                  feeItem
                ]
              })
            }
          );

          var data =
            await response.json();

          if (!response.ok || data.status) {
            throw new Error(
              data.description ||
              data.message ||
              'Unable to add personalization.'
            );
          }

          /*
           * Mirror Impulse's own successful
           * AJAX product-form event.
           */
          form.dispatchEvent(
            new CustomEvent(
              'ajaxProduct:added',
              {
                detail: {
                  product: data,
                  addToCartBtn: addButton
                },
                bubbles: true
              }
            )
          );

          /*
           * Page-style carts don't have a drawer
           * listening for the event.
           */
          if (
            window.theme &&
            window.theme.settings &&
            window.theme.settings.cartType === 'page'
          ) {
            window.location.href =
              root + 'cart';
          }

        } catch (error) {
          console.error(
            'Personalization add-to-cart error:',
            error
          );

          var oldError =
            form.querySelector(
              '.personalization-cart-error'
            );

          if (oldError) {
            oldError.remove();
          }

          var errorBox =
            document.createElement('div');

          errorBox.className =
            'errors text-center personalization-cart-error';

          errorBox.textContent =
            error.message ||
            'There was a problem adding personalization. Please try again.';

          form.appendChild(errorBox);

        } finally {
          if (addButton) {
            addButton.classList.remove(
              'btn--loading'
            );

            addButton.disabled =
              buttonWasDisabled;
          }
        }
      },
      true
    );
  }

  function initializeWrapper(wrapper) {
    if (
      !wrapper ||
      wrapper.dataset.hotpInitialized === 'true'
    ) {
      return;
    }

    wrapper.dataset.hotpInitialized = 'true';

    bindVariantHandling(wrapper);
    bindInputHandling(wrapper);
    bindFormHandling(wrapper);

    /*
     * Don't trust server-rendered state alone.
     * Check Impulse's actual live option controls.
     */
    syncFromCurrentVariant(wrapper);
    syncDynamicCheckout(wrapper);
  }

  function initializeAll(root) {
    root = root || document;

    if (
      root.matches &&
      root.matches(WRAPPER_SELECTOR)
    ) {
      initializeWrapper(root);
    }

    if (!root.querySelectorAll) return;

    root
      .querySelectorAll(WRAPPER_SELECTOR)
      .forEach(initializeWrapper);
  }

  /*
   * Anything already on the page:
   * normal PDPs, landing-page products, etc.
   */
  function start() {
    initializeAll(document);

    /*
     * Also catch sections/products inserted later,
     * including theme-editor reloads and quick view.
     */
    var observer =
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(
            function (node) {
              if (
                node.nodeType === 1
              ) {
                initializeAll(node);
              }
            }
          );
        });
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start
    );
  } else {
    start();
  }
})();